import script from "./where-will-promotion-posts-be-displayed.vue?vue&type=script&setup=true&lang=js"
export * from "./where-will-promotion-posts-be-displayed.vue?vue&type=script&setup=true&lang=js"

import "./where-will-promotion-posts-be-displayed.vue?vue&type=style&index=0&id=e707634c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e707634c"]])

export default __exports__